import { useEffect } from 'react';
import { useLocation } from 'react-router';

export const useScrollTopOnRouteChange = () => {
  const location = useLocation();
  const { pathname } = location;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
};
